/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useMemo, useState, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
  Box,
  Button,
  DialogContentText,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import { AnexoPreviewV2, CustomFilterV2, DialogDefaultV2, TableV2 } from '../../../components/v2';
import { renderStatus } from 'components/v2/cell-renderers/status';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as actionsNotas from '../../../store/nota/actions';
import * as Role from '../../../constants/role';
import { VINICIUS_ADMIN_EMAIL } from 'utils';
import { compareNotasByColumns } from '../../../utils/notaSort';
import Formulario from './Formulario';
import ResumoCards from './ResumoCards';
import ValidarDialog from './ValidarDialog';
import InvalidarDialog from './InvalidarDialog';

class CardsErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

CardsErrorBoundary.propTypes = {
  children: PropTypes.node,
};

const defaultFilter = () => ({
  inicio: moment().subtract(2, 'months').startOf('month').valueOf(),
  fim: moment().endOf('day').valueOf(),
});

const tipoNotaFilterOptions = [
  { id: 'ALIMENTACAO', nome: 'Alimentação' },
  { id: 'ABASTECIMENTO', nome: 'Abastecimento' },
  { id: 'ADIANTAMENTO', nome: 'Adiantamento' },
  { id: 'COMPRA_MANUTENCAO_VEICULAR', nome: 'Compra Man. Veicular' },
  { id: 'CORREIO', nome: 'Correio' },
  { id: 'HOSPEDAGEM', nome: 'Hospedagem' },
  { id: 'MANUTENCAO_VEICULO', nome: 'Manutenção do Veículo' },
  { id: 'OUTROS', nome: 'Outros' },
  { id: 'PEDAGIO', nome: 'Pedágio/Balça' },
];

const tipoPagamentoFilterOptions = [
  { id: 'APORTE', nome: 'Aporte' },
  { id: 'CARTAO_CORPORATIVO', nome: 'Cartão Corporativo' },
];

const getTipo = (tipo) => {
  if (tipo === 'ABASTECIMENTO') return 'Abastecimento';
  if (tipo === 'ADIANTAMENTO') return 'Adiantamento';
  if (tipo === 'ALIMENTACAO') return 'Alimentação';
  if (tipo === 'HOSPEDAGEM') return 'Hospedagem';
  if (tipo === 'MANUTENCAO_VEICULO') return 'Manutenção do Veículo';
  if (tipo === 'PEDAGIO') return 'Pedágio/Balça';
  if (tipo === 'CORREIO') return 'Correios';
  if (tipo === 'COMPRA_MANUTENCAO_VEICULAR') return 'Compra Manutenção Veicular';
  return 'Outros';
};

const getTipoPagamento = (tipoPagamento) => {
  if (tipoPagamento === 'CARTAO_CORPORATIVO') return 'Cartão Corporativo';
  if (tipoPagamento === 'APORTE') return 'Aporte';
  return 'N/A';
};

const getValidateLabel = (validate) => {
  if (validate === null || validate === 'AGUARDANDO_VALIDACAO') return 'Aguardando Validação';
  if (validate === 'INVALIDADO') return 'Invalidado';
  return 'Validado';
};

/** Normaliza para chave usada em `renderStatus` (chip). */
const normalizeValidateStatus = (validate) => {
  if (validate === null || validate === 'AGUARDANDO_VALIDACAO') {
    return 'AGUARDANDO_VALIDACAO';
  }
  return validate;
};

const NotasV2 = ({
  downloadNotas,
  userAuth,
  validateNota,
  findFotoById,
  exportNota,
  findNotaById,
}) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [openDownloadNotas, setOpenDownloadNotas] = useState(false);
  const [localFilter, setLocalFilter] = useState(defaultFilter);
  const [openNotAnexoModal, setOpenNotAnexoModal] = useState(false);
  const [openReport, setOpenReport] = useState(false);
  const [openAnexoPreview, setOpenAnexoPreview] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [openExport, setOpenExport] = useState(false);
  const [reload, setReload] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [activeStatus, setActiveStatus] = useState(null);

  const [openValidar, setOpenValidar] = useState(false);
  const [openInvalidar, setOpenInvalidar] = useState(false);
  const [actionNotaId, setActionNotaId] = useState(null);
  const [showDespesaFatura, setShowDespesaFatura] = useState(false);

  const isAdmin = () =>
    userAuth && (Role.ADMIN === userAuth.role || Role.SUPER_ADMIN === userAuth.role);

  const apiFilterBase = useMemo(() => {
    const rest = { ...localFilter };
    delete rest.validate;
    return rest;
  }, [localFilter]);

  const apiFilter = useMemo(() => {
    if (activeStatus != null) {
      return { ...localFilter, validate: activeStatus };
    }
    return { ...localFilter };
  }, [localFilter, activeStatus]);

  const onEdit = (rowId) => {
    setOpen(true);
    setId(rowId);
  };

  const onAdd = () => {
    setOpen(true);
    setId(null);
  };

  const onClose = (isSave) => {
    setOpen(false);
    setId(null);
    if (isSave) {
      setReload((r) => !r);
    }
  };

  const headerActions = useMemo(() => {
    const actions = [
      { label: 'Novo', onClick: onAdd, startIcon: <AddIcon />, variant: 'contained' },
      {
        label: 'Exportar',
        onClick: () => setOpenExport(true),
        startIcon: <FileDownloadOutlinedIcon />,
        variant: 'outlined',
      },
      {
        label: 'Relatório',
        onClick: () => setOpenReport(true),
        startIcon: <DescriptionOutlinedIcon />,
        variant: 'outlined',
      },
    ];

    if (userAuth?.email === VINICIUS_ADMIN_EMAIL) {
      actions.push({
        label: 'Download Notas',
        onClick: () => setOpenDownloadNotas(true),
        startIcon: <FileDownloadOutlinedIcon />,
        variant: 'outlined',
      });
    }

    return actions;
  }, [userAuth]);

  const rowActions = [
    {
      key: 'view',
      icon: <AttachFileIcon fontSize="small" />,
      title: 'Ver anexo',
      onClick: (rowId) => {
        findFotoById(rowId, (files) => {
          if (files && files.length > 0) {
            setAttachments(files);
            setOpenAnexoPreview(true);
          } else {
            setOpenNotAnexoModal(true);
          }
        });
      },
    },
    {
      key: 'validate',
      icon: <CheckCircleOutlineIcon fontSize="small" sx={{ color: 'success.main' }} />,
      title: 'Validar',
      show: (row) =>
        isAdmin() && (row.validate === null || row.validate === 'AGUARDANDO_VALIDACAO'),
      onClick: (rowId) => {
        findNotaById(rowId, (nota) => {
          setActionNotaId(rowId);
          setShowDespesaFatura(nota.tipoPagamento === 'CARTAO_CORPORATIVO');
          setOpenValidar(true);
        });
      },
    },
    {
      key: 'invalidate',
      icon: <NotInterestedIcon fontSize="small" sx={{ color: 'error.main' }} />,
      title: 'Invalidar',
      show: (row) =>
        isAdmin() && (row.validate === null || row.validate === 'AGUARDANDO_VALIDACAO'),
      onClick: (rowId) => {
        setActionNotaId(rowId);
        setOpenInvalidar(true);
      },
    },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
          sx={{ pr: 2 }}
        >
          <Typography variant="h4">Notas</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <CardsErrorBoundary>
          <ResumoCards
            apiFilterBase={apiFilterBase}
            activeStatus={activeStatus}
            onFilterByStatus={setActiveStatus}
            refreshKey={reload}
          />
        </CardsErrorBoundary>

        <TableV2
          useApi
          fetchUrl="notas/filter"
          rowHeight={70}
          headerActions={headerActions}
          actions={rowActions}
          columns={[
            {
              field: 'data',
              headerName: 'Data',
              width: 120,
              renderCell: ({ row }) => moment(Number(row.data)).format('DD/MM/YYYY'),
            },
            {
              field: 'tipo',
              headerName: 'Tipo Nota',
              flex: 0.8,
              minWidth: 160,
              renderCell: ({ row }) => (
                <Box 
                  sx={{ 
                    py: 0.5, 
                    lineHeight: 1.2,
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                  }}>
                  {getTipo(row.tipo)}
                  {(row.tipo === 'ABASTECIMENTO' || row.tipo === 'MANUTENCAO_VEICULO') && (
                    <Typography variant="caption" component="div">
                      ({row.veiculoPlaca})
                    </Typography>
                  )}
                </Box>
              ),
            },
            {
              field: 'valor',
              headerName: 'Valor',
              width: 120,
              renderCell: ({ row }) =>
                row.valor?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
            },
            { field: 'usuarioNome', headerName: 'Inspetor', flex: 0.7 },
            {
              field: 'tipoPagamento',
              headerName: 'Tipo Pagamento',
              width: 150,
              renderCell: ({ row }) => getTipoPagamento(row.tipoPagamento),
            },
            { field: 'inspetorAuxiliarNome', headerName: 'Observador/Ajudante', flex: 0.7 },
            {
              field: 'validate',
              headerName: 'Validação',
              width: 200,
              renderCell: ({ row }) =>
                renderStatus({
                  value: normalizeValidateStatus(row.validate),
                  label: getValidateLabel(row.validate),
                }),
            },
          ]}
          onEdit={onEdit}
          filterData={apiFilter}
          refreshKey={reload}
          sortComparator={compareNotasByColumns}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          appliedFilter={localFilter}
          fields={[
            { field: 'useDates' },
            { field: 'useInspetor', md: 6 },
            {
              field: 'useSelectOption',
              key: 'tipoNota',
              label: 'Tipo Nota',
              options: tipoNotaFilterOptions,
              md: 6,
            },
            {
              field: 'useVeiculo',
              key: 'veiculoIds',
              md: 6,
            },
            {
              field: 'useSelectOption',
              key: 'tipoPagamento',
              label: 'Tipo Pagamento',
              options: tipoPagamentoFilterOptions,
              md: 6,
            },
            { field: 'useValidate', md: 6 },
            { field: 'useCartao', md: 6 },
          ]}
          defaultFilter={defaultFilter()}
          onFilter={(filterData) => {
            setActiveStatus(null);
            setLocalFilter(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          isAdmin={isAdmin()}
        />
      </Stack>

      <DialogDefaultV2
        open={openDownloadNotas}
        handlerCancel={() => setOpenDownloadNotas(false)}
        handlerConfirm={() => {
          downloadNotas(localFilter, () => {
            setOpenDownloadNotas(false);
          });
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText>
          Deseja baixar todas os arquivos das notas filtradas?
        </DialogContentText>
      </DialogDefaultV2>

      <ValidarDialog
        open={openValidar}
        showDespesaFatura={showDespesaFatura}
        onClose={() => {
          setOpenValidar(false);
          setActionNotaId(null);
        }}
        onConfirm={({ despesaFatura }) => {
          setOpenValidar(false);
          const payload = { id: actionNotaId, validate: 'VALIDADO' };
          if (showDespesaFatura && despesaFatura !== undefined && despesaFatura !== '') {
            payload.despesaFatura = despesaFatura;
          }
          validateNota(payload, () => setReload((r) => !r));
          setActionNotaId(null);
        }}
      />

      <InvalidarDialog
        open={openInvalidar}
        onClose={() => {
          setOpenInvalidar(false);
          setActionNotaId(null);
        }}
        onConfirm={() => {
          setOpenInvalidar(false);
          validateNota(
            { id: actionNotaId, validate: 'INVALIDADO' },
            () => setReload((r) => !r)
          );
          setActionNotaId(null);
        }}
      />

      <AnexoPreviewV2
        open={openAnexoPreview}
        onClose={() => {
          setOpenAnexoPreview(false);
          setAttachments([]);
        }}
        attachments={attachments}
        title="Anexos da nota"
      />

      <DialogDefaultV2
        open={openNotAnexoModal}
        handlerCancel={() => setOpenNotAnexoModal(false)}
        readOnly
      >
        <DialogContentText>Nota não possui anexo</DialogContentText>
      </DialogDefaultV2>

      <DialogDefaultV2
        open={openExport}
        handlerCancel={() => setOpenExport(false)}
        handlerConfirm={() => {
          exportNota(localFilter, false, () => {
            setOpenExport(false);
          });
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText>Deseja exportar as notas filtradas?</DialogContentText>
      </DialogDefaultV2>

      <DialogDefaultV2
        open={openReport}
        handlerCancel={() => setOpenReport(false)}
        handlerConfirm={() => {
          exportNota(localFilter, true, () => {
            setOpenReport(false);
          });
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText>Deseja gerar o relatório das notas filtradas?</DialogContentText>
      </DialogDefaultV2>
    </Box>
  );
};

NotasV2.propTypes = {
  downloadNotas: PropTypes.func.isRequired,
  userAuth: PropTypes.object,
  validateNota: PropTypes.func.isRequired,
  findFotoById: PropTypes.func.isRequired,
  exportNota: PropTypes.func.isRequired,
  findNotaById: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userAuth: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsNotas,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NotasV2));
